import { IframeModal } from '../iframe-modal';
import React from 'react';
import { getAppPackagePickerUrl } from '../upgrade-app-button/get-app-package-picker-url';
import { useSiteContext } from '@wix/app-market-core';

export interface UpgradeModalProps {
  app: {
    id: string;
    externalPricingPageUrl?: string;
  };
  isOpen: boolean;
  onClose: () => void;
  ppOrigin?: string;
}

export const UpgradeModal = ({
  app,
  isOpen,
  onClose,
  ppOrigin,
}: UpgradeModalProps) => {
  const { metaSiteId } = useSiteContext();

  const appPackagePickerUrl = getAppPackagePickerUrl({
    appId: app.id,
    metaSiteId: metaSiteId as string,
    isModalEnabled: true,
    ppOrigin,
  });
  return (
    <IframeModal
      isOpen={isOpen}
      onClose={onClose}
      url={appPackagePickerUrl}
      title="Upgrade App"
    />
  );
};
